<template>
  <el-form-item
    v-if="isBackOnly"
  >
    <el-button
      type="info"
      icon="el-icon-arrow-left"
      @click="backList"
    >
      {{ $t('api.backListBtn') }}
    </el-button>
  </el-form-item>
  <el-form-item
    v-else
  >
    <el-button
      v-if="hasSave"
      type="primary"
      native-type="submit"
      @click.native.prevent="submitForm(false)"
      :loading="submitLoading"
    >
      {{ $t('api.saveBtn') }}
    </el-button>
    <el-button
      v-if="isEdit && hasSaveAs"
      type="primary"
      :plain="hasSave"
      @click="submitForm(true)"
      :loading="submitLoading"
    >
      {{ $t('api.saveAsBtn', { dataName: $t('api.' + base + '.name') }) }}
    </el-button>
    <el-button
      @click="backList"
    >
      {{ $t('api.cancelBtn') }}
    </el-button>
  </el-form-item>
</template>

<script>

import _ from 'lodash'
import { transText } from '@/utils/i18n'
import Fetch from '@/mixins/fetch'

export default {
  name: 'form-btn',
  mixins: [Fetch],
  props: {
    base: {
      type: String,
      required: true
    },
    idField: {
      type: String,
      default: 'id'
    },
    formValid: {
      type: Function,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    platform: {
      type: String
    },
    create: {
      type: Function,
      default: () => {}
    },
    updateOne: {
      type: Function,
      default: () => {}
    },
    afterUpdateOne: {
      type: Function,
      required: false
    },
    beforeSubmit: {
      type: Function,
      default: () => {}
    },
    beforeSaveAs: {
      type: Function,
      default: () => {}
    },
    afterSubmitOK: {
      type: Function,
      default: () => {}
    },
    hasSave: {
      type: Boolean,
      default: true
    },
    hasSaveAs: {
      type: Boolean,
      default: true
    },
    isBackOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      submitLoading: false
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    transText,
    backList () {
      let view = { path: this.$route.path }
      this.$store.dispatch('delVisitedViews', view).then((views) => {
        let r = this.$store.getters.referer
        if (this.isEdit) {
          if (!r) {
            this.$router.go(-1)
          } else {
            if (r.path === '/') {
              let arr = view.path.split('/')
              arr.splice(-2, 2)
              let path = arr.join('/') + '/list'
              this.$router.push({
                path: path,
                query: { page: 1 }
              })
            } else {
              this.$router.push(r)
            }
          }
        } else {
          if (r.path.endsWith('/list')) {
            let arr = view.path.split('/')
            arr.splice(-1, 1)
            let listPath = arr.join('/') + '/list'
            let query = {}
            for (let i = 0; i < this.$store.state.tagsView.visitedViews.length; i++) {
              let v = this.$store.state.tagsView.visitedViews[i]
              if (v.path === listPath) {
                query = v.query
                break
              }
            }
            query.page = 1
            this.$router.push({
              path: './list',
              query: query
            })
          } else {
            this.$router.push(r)
          }
        }
      })
    },
    submitForm (isSaveAs, afterFunc) {
      let data = _.cloneDeep(this.formData)
      let ret = this.beforeSubmit(data, isSaveAs)
      this.formValid((valid, invalidFields) => {
        if (!valid) {
          this.$_alert(invalidFields)
          return false
        }
        this.confirmAndSubmit(ret, isSaveAs, data, afterFunc)
      })
    },
    async confirmAndSubmit (ret, isSaveAs, data, afterFunc) {
      if (!await this.confirm(ret)) {
        return
      }
      if (!await this.validTrans(isSaveAs, data)) {
        return
      }
      this.submitData(isSaveAs, data, afterFunc)
    },
    async confirm (ret) {
      if (typeof ret === 'undefined' || !ret.isNeedConfirm) {
        return true
      }
      let res = await this.$confirm(
        ret.confirmMsg,
        ret.confirmTitle,
        {
          confirmButtonText: this.$t('api.confirmBtn'),
          cancelButtonText: this.$t('api.cancelBtn'),
          confirmButtonClass: 'el-button--danger',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).catch(() => {
        // do nothing
      })
      return res
    },
    async validTrans (isSaveAs, data) {
      if (data.trans === 'undefined') {
        return true
      }
      let valid = true
      let noTrans = {}
      let t = data.trans
      for (let idx in t) {
        Object.keys(t[idx]).map((key, i) => {
          let pos = key.lastIndexOf('_status')
          if (pos !== -1) {
            if (t[idx][key] !== 1) {
              let fname = key.substr(0, pos)
              if (!t[idx].hasOwnProperty(fname + '_hidden')) {
                noTrans[fname] = true
                valid = false
              }
            }
            // Mark translation status as not completed when save as new data
            if (isSaveAs) {
              t[idx][key] = 0
            }
          }
        })
      }
      if (valid) {
        return true
      }

      let msgs = []
      Object.keys(noTrans).map((key, i) => {
        msgs.push('<b>' + this.transText(this.base + '.fields.' + key + '.label') + '</b><br/>')
      })
      let msg = msgs.join('') + this.$t('api.trans.confirmMsg')
      let res = await this.$confirm(msg, this.$t('api.transText'), {
        confirmButtonText: this.$t('api.saveBtn'),
        cancelButtonText: this.$t('api.cancelBtn'),
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).catch(() => {
        // do nothing
      })
      return res
    },
    submitData (isSaveAs, data, afterFunc) {
      this.submitLoading = true
      if (isSaveAs || !this.isEdit) {
        if (isSaveAs) {
          this.beforeSaveAs(data)
        }
        this.create(data, this.platform).then(res => {
          this.$message({
            message: this.transText(this.base + '.addSuccess'),
            type: 'success',
            duration: 2000
          })
          this.afterSubmitOK(res)
          this.backList()
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.submitLoading = false
        })
      } else {
        let id = data[this.idField]
        this.updateOne(id, data, this.platform).then(res => {
          if (this.afterUpdateOne) {
            if (this.afterUpdateOne(res, id)) {
              this.submitLoading = false
              return
            }
          }
          this.$message({
            message: this.transText(this.base + '.editSuccess'),
            type: 'success',
            duration: 2000
          })
          this.afterSubmitOK(res)
          if (typeof afterFunc === 'function') {
            afterFunc()
          } else {
            this.backList()
          }
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.submitLoading = false
        })
      }
    }
  }
}
</script>
